import React from "react";
import { NavLink, Forbidden, Authorized } from "MODULES/shared/components";
import {
  ROLES_WITHOUT_ADMIN_WH,
  WAREHOUSE,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";

export default function Menu() {
  return (
    <ul className="nav navbar-nav visible-xs">
      <Forbidden roles={[WAREHOUSE]}>
        <NavLink path="/parts" icon="fa-cogs" title="Parts" listId="parts" />
      </Forbidden>
      <Authorized
        roles={ROLES_WITHOUT_ADMIN_WH}
        subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
      >
        <NavLink
          path="/incoming-quotes"
          icon="fa-quote-left"
          title="Incoming Quotes"
          listId="incomingQuotes"
        />
        <NavLink
          path="/outgoing-quotes"
          icon="fa-quote-right"
          title="Outgoing Quotes"
          listId="outgoingQuotes"
        />
      </Authorized>
      <Forbidden roles={[WAREHOUSE]}>
        <NavLink
          path="/purchase-orders"
          icon="fa-shopping-cart"
          title="Purchase Orders"
          listId="purchaseOrders"
        />
        <NavLink
          path="/sales-orders"
          icon="fa-dollar"
          title="Sales Orders"
          listId="salesOrders/search"
        />
        <NavLink
          path="/repair-orders"
          icon="fa-wrench"
          title="Repair Orders"
          listId="repairOrders"
        />
        <NavLink
          path="/customer-rmas"
          icon="fa-cog"
          title="Customer RMAs"
          listId="customerRmas"
        />
        <NavLink
          path="/vendor-rmas"
          icon="fa-shield"
          title="Vendor RMAs"
          listId="vendorRmas"
        />
      </Forbidden>
      <NavLink
        path="/receiving"
        icon="fa-truck"
        title="Receiving Records"
        listId="receivingRecords"
      />
      <NavLink
        path="/shipping"
        icon="fa-external-link"
        title="Shipped Orders"
        listId="shipments"
      />
      <Forbidden roles={[WAREHOUSE]}>
        <NavLink
          path="/companies"
          icon="fa-building"
          title="Companies"
          listId="companies"
        />
        <NavLink path="/users" icon="fa-users" title="Users" listId="users" />
      </Forbidden>
    </ul>
  );
}



// WEBPACK FOOTER //
// ./app/Nav/Menu.jsx